import React, { useState } from "react";
import Header from "../components/Header";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";

import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import "../assets/css/menu.css";
import "../assets/css/vendors.css";
import "../assets/css/icon_fonts/css/all_icons_min.css";
import "../assets/css/custom.css";

const doctorsData = [
  {
    name: "Dr. Rajesh Kumar",
    qualification: "MBBS, MS - Vascular Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "15 Years Experience",
    location: "2nd Floor, MS Tower, Banjara Hills, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "AV Fistula Creation Specialist"
  },
  {
    name: "Dr. Anil Sharma",
    qualification: "MBBS, MCh - Vascular Surgery",
    fee: " FREE Consultation",
    rating: "4.9/5",
    experience: "12 Years Experience",
    location: "Apurupa Urban, No 201, 2nd Floor, Image Gardens Rd, near Chirec School, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Dialysis Access Expert"
  },
  {
    name: "Dr. Vikram Singh",
    qualification: "MBBS, MS - General Surgery",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "14 Years Experience",
    location: "Annapurna Kalyana Mandapam Srinagar Nagar, Dilsukhnagar, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "AV Fistula Repair Specialist"
  },
  {
    name: "Dr. Sanjay Reddy",
    qualification: "MBBS, MD - Nephrology",
    fee: " FREE Consultation",
    rating: "4.6/5",
    experience: "11 Years Experience",
    location: "123 Green Avenue, Banjara Hills, Hyderabad",
    phone: "080-6541-7710",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Renal Care Access Expert"
  },
  {
    name: "Dr. Arun Patel",
    qualification: "MBBS, MS - Vascular Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "16 Years Experience",
    location: "45 Tower Road, Jubilee Hills, Hyderabad",
    phone: "080-6541-7720",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Advanced AV Fistula Care"
  },
  {
    name: "Dr. Mohan Das",
    qualification: "MBBS, DNB - Nephrology",
    fee: "FREE Consultation",
    rating: "4.7/5",
    experience: "13 Years Experience",
    location: "21 MG Road, Hyderabad",
    phone: "080-6541-7730",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Dialysis Access Management"
  },
];

const DoctorsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedDoctors = showAll ? doctorsData : doctorsData.slice(0, 6);

  return (
    <div style={{ padding: "80px 20px", backgroundColor: "#f8f9fa" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", fontFamily: "'Poppins', sans-serif" }}>
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h2 style={{ fontSize: "42px", fontWeight: "800", color: "#0b1c39", marginBottom: "15px" }}>
            Our <span style={{ color: "#ffcb24" }}>AV Fistula Specialists</span>
          </h2>
          <p style={{ fontSize: "18px", color: "#555", maxWidth: "600px", margin: "0 auto", lineHeight: "1.8" }}>
            Expert surgical care for comprehensive AV fistula creation, maintenance, and complication management.
          </p>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", justifyContent: "space-between" }}>
          {displayedDoctors.map((doc, index) => (
            <div
              key={index}
              style={{
                flex: "0 0 calc(33.33% - 17px)",
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "25px",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                border: "1px solid rgba(9,187,175,0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 12px 35px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.08)";
              }}
            >
              <div style={{ position: "relative", flexShrink: 0 }}>
                <img
                  src={doc.image}
                  alt={doc.name}
                  style={{
                    width: "95px",
                    height: "95px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #09bbaf",
                    backgroundColor: "#f8f8f8",
                  }}
                />
                {doc.online && (
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "8px",
                      width: "14px",
                      height: "14px",
                      backgroundColor: "#09bbaf",
                      borderRadius: "50%",
                      border: "2px solid #fff",
                    }}
                    title="Online"
                  ></span>
                )}
              </div>

              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#0b1c39", marginBottom: "6px" }}>
                  {doc.name}
                </h3>
                <p style={{ color: "#09bbaf", fontSize: "14px", marginBottom: "6px", fontWeight: "600" }}>
                  {doc.specialization}
                </p>
                <p style={{ color: "#555", fontSize: "14px", marginBottom: "6px" }}>
                  {doc.qualification}
                </p>
                <p style={{ fontWeight: "600", color: "#09bbaf", marginBottom: "6px", fontSize: "15px" }}>
                  {doc.fee}
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "14px", color: "#555" }}>⭐ {doc.rating}</span>
                  <span style={{ fontSize: "14px", color: "#555" }}>{doc.experience}</span>
                </div>
                <p style={{ fontSize: "13px", color: "#555", display: "flex", alignItems: "flex-start", gap: "6px", marginBottom: "6px", lineHeight: "1.4" }}>
                  📍 {doc.location}
                </p>
                <p style={{ fontSize: "13px", color: "#555", marginBottom: "15px" }}>
                  📞 {doc.phone}
                </p>

                <button
                  style={{
                    padding: "12px 20px",
                    border: "none",
                    borderRadius: "30px",
                    backgroundColor: "#ffcb24",
                    color: "#0b1c39",
                    cursor: "pointer",
                    width: "100%",
                    fontWeight: "600",
                    fontSize: "14px",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#ffd84f")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffcb24")}
                >
                  Book Free Consultation
                </button>
              </div>
            </div>
          ))}
        </div>

        {!showAll && doctorsData.length > 6 && (
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <button
              onClick={() => setShowAll(true)}
              style={{
                padding: "14px 40px",
                fontSize: "16px",
                borderRadius: "12px",
                border: "none",
                backgroundColor: "#09bbaf",
                color: "#fff",
                cursor: "pointer",
                fontWeight: "700",
                boxShadow: "0 8px 25px rgba(9,187,175,0.3)",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0dcfc2")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#09bbaf")}
            >
              View More Doctors ▼
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const AVFistulaTreatment = () => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <>
      <Header />
      <Header2 />

      {/* Hero Section */}
      <section style={{
        background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
        padding: "160px 0 100px",
        marginTop: "56px",
        color: "white",
        textAlign: "center",
        position: "relative",
        overflow: "hidden"
      }}>
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <h1 style={{
            fontSize: "3.5rem",
            fontWeight: "800",
            marginBottom: "20px",
            color: "white"
          }}>
            Advanced AV Fistula Treatment
          </h1>
          <p style={{
            fontSize: "1.3rem",
            marginBottom: "30px",
            opacity: "0.9",
            maxWidth: "700px",
            margin: "0 auto 30px",
            lineHeight: "1.6"
          }}>
            Surgical Excellence with 95% Success Rate. Lifeline Vascular Access for Hemodialysis Patients.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book Free Consultation
            </button>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "2px solid #ffcb24",
              backgroundColor: "transparent",
              color: "#ffcb24",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.color = "#0b1c39";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#ffcb24";
            }}>
              Dialysis Access Planning
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ backgroundColor: "#fff", padding: "60px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>95%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Surgical Success Rate</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>2-4</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Months Maturation Time</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>3-5</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Years Average Lifespan</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>60%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Fewer Infections vs Catheters</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Doctors Section */}
      <DoctorsSection />

      {/* Navigation Tabs */}
      <section style={{ backgroundColor: "#fff", padding: "40px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
            {[
              { id: "overview", label: "Overview", icon: "📋" },
              { id: "types", label: "Types", icon: "🔍" },
              { id: "procedure", label: "Procedure", icon: "🎯" },
              { id: "maturation", label: "Maturation", icon: "🔬" },
              { id: "complications", label: "Complications", icon: "⚕️" },
              { id: "care", label: "Aftercare", icon: "🔄" },
              { id: "faq", label: "FAQ", icon: "🛡️" }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: "12px 24px",
                  borderRadius: "25px",
                  border: "none",
                  backgroundColor: activeTab === tab.id ? "#09bbaf" : "#f8f9fa",
                  color: activeTab === tab.id ? "white" : "#555",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container" style={{ padding: "80px 15px" }}>

        {/* Comprehensive Overview */}
        <section style={{ marginBottom: "80px" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2 style={{ fontSize: "36px", fontWeight: "800", color: "#0b1c39", marginBottom: "20px" }}>
              Complete Guide to <span style={{ color: "#09bbaf" }}>AV Fistula Treatment</span>
            </h2>
          </div>

          {/* What is AV Fistula */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "50px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "1px solid rgba(9,187,175,0.1)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px" }}>
                Understanding AV Fistula
              </h3>
              
              <p style={{ color: "#555", lineHeight: "1.8", fontSize: "1.1rem", marginBottom: "25px" }}>
                An arteriovenous (AV) fistula is a surgical connection created between an artery and a vein, 
                typically in the arm, to provide reliable vascular access for hemodialysis in patients with 
                end-stage renal disease. This procedure creates a high-flow circuit that allows for efficient 
                blood purification during dialysis treatments.
              </p>

              <div className="row">
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #09bbaf",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Gold Standard Access</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      AV fistula is considered the preferred vascular access for hemodialysis due to its 
                      superior longevity, lower infection rates, and fewer complications compared to 
                      catheters or synthetic grafts.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #ffcb24",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Physiological Benefits</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      The connection causes venous dilation and arterialization, creating vessels with 
                      sufficient flow rates (600-1200 ml/min) needed for efficient hemodialysis while 
                      withstanding repeated needle punctures.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Types of AV Fistulas */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Types of AV Fistulas & Access Options
            </h3>

            <div className="row">
              {[
                {
                  title: "Radiocephalic (Brescia-Cimino)", 
                  description: "Connection between radial artery and cephalic vein at wrist level - first choice for primary access",
                  details: "Most distal site, preserves proximal sites for future access"
                },
                {
                  title: "Brachiocephalic", 
                  description: "Connection between brachial artery and cephalic vein in elbow region",
                  details: "Higher flow rates, suitable when wrist vessels inadequate"
                },
                {
                  title: "Brachibasilic", 
                  description: "Connection between brachial artery and basilic vein with transposition",
                  details: "Requires vein elevation to superficial position"
                },
                {
                  title: "AV Graft", 
                  description: "Synthetic tube connecting artery and vein when native vessels insufficient",
                  details: "Higher complication rates but useful when options limited"
                },
                {
                  title: "Upper Arm Fistulas", 
                  description: "Various configurations in upper arm using available vessels",
                  details: "Good flow rates, easier needle placement"
                },
                {
                  title: "Lower Extremity Fistulas", 
                  description: "Created in thigh when upper extremity options exhausted",
                  details: "Higher infection risk, considered last resort"
                }
              ].map((type, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <div style={{
                    backgroundColor: "#fff",
                    borderRadius: "15px",
                    padding: "25px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                    border: "1px solid rgba(9,187,175,0.1)",
                    height: "100%",
                    transition: "transform 0.3s ease"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                      {type.title}
                    </h5>
                    <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                      {type.description}
                    </p>
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      padding: "12px",
                      borderLeft: "3px solid #09bbaf"
                    }}>
                      <p style={{ color: "#666", fontSize: "0.9rem", lineHeight: "1.5", margin: 0 }}>
                        {type.details}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Surgical Procedure Details */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Surgical Procedure & Techniques
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    type: "Pre-operative Evaluation",
                    description: "Comprehensive vascular mapping with ultrasound to assess vessel size, quality, and flow characteristics",
                    treatment: "Vessel diameter >2mm, adequate inflow and outflow essential"
                  },
                  {
                    type: "Anesthesia Options",
                    description: "Local anesthesia with sedation, regional blocks, or general anesthesia based on patient and procedure complexity",
                    treatment: "Most performed under local anesthesia with monitoring"
                  },
                  {
                    type: "Surgical Technique",
                    description: "End-to-side anastomosis most common; precise microsurgical connection under magnification",
                    treatment: "2-3 hour procedure, outpatient or short stay"
                  },
                  {
                    type: "Intraoperative Monitoring",
                    description: "Doppler ultrasound to confirm adequate flow, thrill presence, and anastomosis patency",
                    treatment: "Target flow rates 600-1200 ml/min"
                  },
                  {
                    type: "Wound Closure",
                    description: "Layered closure with absorbable sutures, sterile dressing application, arm elevation",
                    treatment: "Minimal scarring, early mobilization encouraged"
                  },
                  {
                    type: "Post-operative Care",
                    description: "Immediate monitoring for complications, pain management, discharge with care instructions",
                    treatment: "Follow-up in 2 weeks for suture removal"
                  }
                ].map((type, index) => (
                  <div key={index} className="col-lg-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "2px solid #09bbaf",
                      height: "100%"
                    }}>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                        {type.type}
                      </h5>
                      <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                        {type.description}
                      </p>
                      <div style={{
                        backgroundColor: "#09bbaf",
                        color: "white",
                        padding: "8px 15px",
                        borderRadius: "20px",
                        display: "inline-block",
                        fontSize: "0.9rem",
                        fontWeight: "600"
                      }}>
                        {type.treatment}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Maturation Process */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#0b1c39",
              borderRadius: "20px",
              padding: "50px",
              color: "white"
            }}>
              <h3 style={{ fontSize: "28px", fontWeight: "800", marginBottom: "30px", color: "#ffcb24" }}>
                Fistula Maturation & Development
              </h3>
              
              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Maturation Timeline</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Week 1-2: Initial healing, swelling reduction</li>
                      <li style={{ marginBottom: "10px" }}>Week 3-6: Venous dilation and arterialization begins</li>
                      <li style={{ marginBottom: "10px" }}>Month 2-3: Adequate maturation for cannulation</li>
                      <li style={{ marginBottom: "10px" }}>Month 3-4: Optimal wall thickening and flow rates</li>
                      <li>Month 6: Full maturation achieved</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Maturation Exercises</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Hand grip exercises with soft ball</li>
                      <li style={{ marginBottom: "10px" }}>Forearm strengthening exercises</li>
                      <li style={{ marginBottom: "10px" }}>Blood pressure cuff application (mild)</li>
                      <li style={{ marginBottom: "10px" }}>Avoid heavy lifting during early phase</li>
                      <li>Regular thrill monitoring</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Options */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive Management Approaches
            </h3>

            <div className="row">
              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #09bbaf",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Post-operative Care & Monitoring
                  </h4>
                  
                  <p style={{ color: "#555", lineHeight: "1.8", marginBottom: "25px" }}>
                    Comprehensive care following AV fistula creation is crucial for successful maturation 
                    and long-term functionality. Regular monitoring and proper care prevent complications.
                  </p>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Immediate Post-op Care:</h6>
                    <div className="row">
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Arm elevation to reduce swelling</li>
                          <li style={{ marginBottom: "8px" }}>Regular thrill and bruit checks</li>
                          <li style={{ marginBottom: "8px" }}>Wound care and hygiene</li>
                        </ul>
                      </div>
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Pain management</li>
                          <li style={{ marginBottom: "8px" }}>Avoid blood pressure measurements</li>
                          <li style={{ marginBottom: "8px" }}>No venipuncture in access arm</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Long-term Monitoring:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "8px" }}>Regular physical examination</li>
                      <li style={{ marginBottom: "8px" }}>Doppler ultrasound surveillance</li>
                      <li style={{ marginBottom: "8px" }}>Flow rate measurements</li>
                      <li>Prompt intervention for complications</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #ffcb24",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Complication Management
                  </h4>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Common Complications:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Thrombosis and stenosis</li>
                      <li style={{ marginBottom: "10px" }}>Infection and bleeding</li>
                      <li style={{ marginBottom: "10px" }}>Steal syndrome</li>
                      <li style={{ marginBottom: "10px" }}>Aneurysm formation</li>
                      <li>Venous hypertension</li>
                    </ul>
                  </div>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Interventional Treatments:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Angioplasty for stenosis</li>
                      <li style={{ marginBottom: "10px" }}>Thrombectomy for clots</li>
                      <li style={{ marginBottom: "10px" }}>Stent placement</li>
                      <li style={{ marginBottom: "10px" }}>Surgical revision</li>
                      <li>New access creation if needed</li>
                    </ul>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Prevention Strategies:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Proper needle rotation</li>
                      <li style={{ marginBottom: "10px" }}>Adequate compression post-dialysis</li>
                      <li>Regular surveillance and early intervention</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Success Timeline */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Treatment Success Timeline
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    period: "Day 1-7",
                    title: "Immediate Post-op",
                    activities: ["Surgical healing", "Swelling reduction", "Thrill establishment", "Pain management"]
                  },
                  {
                    period: "Week 2-8",
                    title: "Early Maturation",
                    activities: ["Venous dilation", "Wall thickening", "Exercise initiation", "Flow improvement"]
                  },
                  {
                    period: "Month 2-4",
                    title: "Cannulation Ready",
                    activities: ["Adequate maturation", "First successful dialysis", "Regular monitoring", "Complication check"]
                  },
                  {
                    period: "Month 6+",
                    title: "Long-term Use",
                    activities: ["Full functionality", "Routine dialysis", "Surveillance continues", "Preventive care"]
                  }
                ].map((stage, index) => (
                  <div key={index} className="col-lg-3 col-md-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      textAlign: "center",
                      border: "1px solid rgba(9,187,175,0.2)",
                      height: "100%"
                    }}>
                      <div style={{ 
                        backgroundColor: "#09bbaf", 
                        color: "white", 
                        width: "60px", 
                        height: "60px", 
                        borderRadius: "50%", 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        margin: "0 auto 15px",
                        fontWeight: "700",
                        fontSize: "0.9rem"
                      }}>
                        {stage.period}
                      </div>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {stage.title}
                      </h5>
                      <ul style={{ color: "#555", fontSize: "0.85rem", paddingLeft: "15px", textAlign: "left" }}>
                        {stage.activities.map((activity, idx) => (
                          <li key={idx} style={{ marginBottom: "8px" }}>{activity}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Patient Education */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "2px solid rgba(255,203,36,0.3)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px", textAlign: "center" }}>
                Patient Education & Self-Care
              </h3>

              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Daily Monitoring</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Check for thrill (buzzing sensation) daily</li>
                      <li style={{ marginBottom: "10px" }}>Listen for bruit (whooshing sound)</li>
                      <li style={{ marginBottom: "10px" }}>Monitor for swelling or redness</li>
                      <li>Report changes immediately</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Protection Measures</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>No blood pressure on access arm</li>
                      <li style={{ marginBottom: "10px" }}>Avoid tight clothing or jewelry</li>
                      <li style={{ marginBottom: "10px" }}>Sleep on opposite side</li>
                      <li>Carry heavy objects with other arm</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Frequently Asked Questions
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              {[
                {
                  question: "How long does an AV fistula last?",
                  answer: "A well-maintained AV fistula can typically last for many years, with an average lifespan of 3-5 years, though many function well for a decade or longer with proper care. The longevity depends on several factors: the quality of blood vessels at creation, the patient's overall health and comorbidities, how well the fistula is cared for and monitored, the skill of dialysis staff in needle placement, and prompt management of any complications. Native AV fistulas (using patient's own vessels) generally last longer than synthetic grafts. Regular surveillance and early intervention for problems like stenosis can significantly extend fistula lifespan. Some patients have successfully used the same fistula for over 10 years with excellent care."
                },
                {
                  question: "What is the success rate of AV fistula surgery?",
                  answer: "AV fistula creation has a high technical success rate of approximately 95% when performed by experienced vascular surgeons. However, the clinical success rate (fistula that matures adequately for dialysis use) is about 60-70% for wrist fistulas and 80-90% for upper arm fistulas. Success depends on several factors: adequate vessel size and quality (vein diameter >2mm, artery diameter >1.5mm), surgical technique and experience, patient factors like diabetes and vascular disease, and proper post-operative care and maturation exercises. Failed maturation is the most common reason for clinical failure, often due to inadequate venous outflow or development of stenosis. Pre-operative vascular mapping significantly improves success rates by identifying the best vessels for creation."
                },
                {
                  question: "How soon after surgery can the fistula be used for dialysis?",
                  answer: "An AV fistula requires a maturation period before it can be safely used for dialysis. The typical timeline is: Radiocephalic (wrist) fistulas: 2-4 months maturation time; Brachiocephalic (elbow) fistulas: 1-3 months; Brachiobasilic fistulas: 3-4 months. The fistula is ready when the vein has adequately dilated (minimum 6mm diameter), the wall has thickened sufficiently to withstand repeated needle punctures, and blood flow reaches at least 600 ml/min. Early cannulation (before 4-6 weeks) can damage the developing fistula and lead to failure. The surgical team will monitor maturation through physical examination and ultrasound, and provide clearance when the fistula is ready for use. Temporary dialysis access via catheter is typically used during the maturation period."
                },
                {
                  question: "What are the signs that my AV fistula is working properly?",
                  answer: "Several signs indicate a properly functioning AV fistula: A palpable 'thrill' - a continuous buzzing or vibration sensation over the fistula; An audible 'bruit' - a whooshing sound heard with a stethoscope; Visible vein dilation and prominence; Warmth in the area around the fistula; Ability to feel a strong pulse in the vein; No significant swelling, redness, or pain. Patients should check these signs daily and report any changes immediately. Loss of thrill or bruit, development of swelling, pain, skin changes, or difficulty with needle insertion during dialysis are warning signs that require prompt medical attention. Regular monitoring helps detect problems early when they are most easily treatable."
                },
                {
                  question: "What complications can occur with AV fistulas?",
                  answer: "While AV fistulas are the safest dialysis access option, several complications can occur: Thrombosis (clotting) - the most common complication; Stenosis (narrowing) - often at the anastomosis site; Infection - much less common than with catheters; Steal syndrome - where blood is 'stolen' from the hand causing coldness and pain; Aneurysm formation - bulging of the vein wall; Venous hypertension - swelling of the hand and arm; Heart failure - in patients with very high flow rates. Most complications are treatable with procedures like angioplasty, stenting, or surgical revision. Regular monitoring, proper needle rotation during dialysis, and prompt reporting of changes can prevent many complications. The multidisciplinary vascular access team manages these issues to preserve fistula function."
                }
              ].map((faq, index) => (
                <div key={index} style={{ 
                  marginBottom: "25px",
                  paddingBottom: "25px",
                  borderBottom: index < 4 ? "1px solid #eee" : "none"
                }}>
                  <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "10px" }}>
                    {faq.question}
                  </h5>
                  <p style={{ color: "#555", lineHeight: "1.6", margin: 0 }}>
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Final CTA */}
          <div style={{
            background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
            borderRadius: "20px",
            padding: "60px 40px",
            textAlign: "center",
            color: "white"
          }}>
            <h2 style={{ fontSize: "2.5rem", fontWeight: "800", marginBottom: "20px" }}>
              Need Expert AV Fistula Care?
            </h2>
            <p style={{ fontSize: "1.2rem", marginBottom: "30px", opacity: "0.9", maxWidth: "600px", margin: "0 auto 30px" }}>
              Our vascular surgery team provides comprehensive AV fistula creation and management with advanced surgical techniques.
            </p>
            <button style={{
              padding: "18px 45px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "800",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book FREE Consultation Now
            </button>
            <p style={{ marginTop: "20px", fontSize: "1rem", opacity: "0.8" }}>
              Vascular Surgery: <strong>080-6541-7705</strong> | Dialysis Access: <strong>080-6541-7713</strong>
            </p>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default AVFistulaTreatment;